import * as React from "react";

export class MarketCount extends React.Component<{ value: string, link?: string }, {}> {

    render() {
        return (
            <a href={ this.props.link || "javascript:void(0);"} className="rj-sports-multiview__event-card-section rj-sports-multiview__market_count">
                <div className="rj-sports-multiview__event-section-content">
                    <div>{this.props.value}</div>
                </div>
            </a>
        )
    }
}